import { Tooltip, TooltipWithBounds, defaultStyles } from '@visx/tooltip';
import { timeFormat } from 'd3';
import React from 'react';

const formatDate = timeFormat('%b %d, %Y');

const formatTooltipValue = (value) => {
  if (value == null || isNaN(value)) return '';
  const absValue = Math.abs(value);

  if (absValue >= 1e12) return (value / 1e12).toFixed(1) + 'T';
  if (absValue >= 1e9) return (value / 1e9).toFixed(1) + 'B';
  if (absValue >= 1e6) return (value / 1e6).toFixed(1) + 'M';
  if (absValue >= 1e3) return (value / 1e3).toFixed(1) + 'K';

  return value.toFixed(1);
};

const tooltipBoundsStyle = {
  backgroundColor: 'white',
  color: 'black',
  padding: '5px',
  fontSize: '12px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  borderRadius: '4px',
  position: 'absolute',
  pointerEvents: 'none',
  zIndex: 10,
};

const bottomTooltipStyle = {
  ...defaultStyles,
  minWidth: 11,
  fontSize: 12,
  textAlign: 'center',
  transform: 'translateX(-50%)',
  whiteSpace: "nowrap",
  pointerEvents: 'none',
  zIndex: 10,
};

const ChartTooltip = ({
  tooltipData,
  tooltipTop = 0,
  tooltipLeft = 0,
  dimensions = {},
  chartType
}) => {
  if (!tooltipData) return null;

  const rawDate = tooltipData.recordDate || tooltipData.date;
  const validDate = rawDate instanceof Date ? rawDate : new Date(rawDate);
  const isDateValid = !isNaN(validDate.getTime());

  const bottomTooltipTop = (dimensions?.innerHeight || 0) + (dimensions?.margin?.top || 0) - 10;

  return (
    <div>
      <TooltipWithBounds
        top={tooltipTop - 47}
        left={tooltipLeft}
        style={tooltipBoundsStyle}
      >
        {formatTooltipValue(tooltipData.value)}
      </TooltipWithBounds>

      <Tooltip
        top={bottomTooltipTop}
        left={tooltipLeft}
        style={bottomTooltipStyle}
      >
        {isDateValid ? formatDate(validDate) : ''}
      </Tooltip>
    </div>
  );
};

export default ChartTooltip;